import comp from "./WorksheetTimer";
export default comp;
